import type { AliasDto } from "@bafe/api-client";

/** An extra address that lands in a mailbox on this workspace. */
export function isMailboxAlias(alias: AliasDto): boolean {
	return alias.destinationType === "mailbox";
}

/** An address that sends mail on to another email. */
export function isForwarder(alias: AliasDto): boolean {
	return alias.destinationType === "external";
}
